import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import commonenTranslation from "./locales/en/common.json";
import enTranslation from "./locales/en/translation.json";
import validationenTranslation from "./locales/en/validation.json";

import commondeTranslation from "./locales/de/common.json";
import deTranslation from "./locales/de/translation.json";
import validationdeTranslation from "./locales/en/validation.json";

import commonesTranslation from "./locales/es/common.json";
import commonfrTranslation from "./locales/fr/common.json";
import commonitTranslation from "./locales/it/common.json";
import commonjaTranslation from "./locales/ja/common.json";
import commonptbrTranslation from "./locales/pt-br/common.json";

export const defaultNS = "common";
export const fallbackNS = "fallback";

const resources = {
  en: {
    common: commonenTranslation,
    translation: enTranslation,
    validation: validationenTranslation,
  },
  de: {
    common: commondeTranslation,
    translation: deTranslation,
    validation: validationdeTranslation,
  },
  es: {
    common: commonesTranslation,
  },
  fr: {
    common: commonfrTranslation,
  },
  it: {
    common: commonitTranslation,
  },
  ja: {
    common: commonjaTranslation,
  },
  "pt-br": {
    common: commonptbrTranslation,
  },
};

i18next.use(initReactI18next).use(LanguageDetector).init({
  resources,
  // debug: true,
  fallbackLng: "en",
  defaultNS,
  fallbackNS,
});

export default i18next;
